import { UserService } from './user.service';
import { album } from "./../models/album.model";
import { media } from "./../models/media.model";
import { artist } from "./../models/artist.model";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable()
export class MediaService {
  medias: media[] = [];

  constructor(private http: HttpClient, private uService: UserService) {}

  ngOnInit() {}

  load(id: number) {

    return new Promise((resolve)  => {

      if (!this.medias[id]) {
        this.http.get("https://minmusik.se/api/media/" + id + "?user_id=" + this.uService.user.id).subscribe(m => {

            let item: media = new media();
            item.id = m["id"];
            item.title = m["title"];
            item.path = m["path"];
            item.type = m["type"];
            item.access = m["access"];
            item.price = m["price"];

            let alb = new album();
            alb.id = m["album"]["id"];
            alb.title = m["album"]["title"];
            alb.cover_url = m["album"]["cover_url"];
            item.album = alb;

            item.album.artists = [];
            item.album.artist_string = "";

            for (let j in m["album"]["artists"]) {
              let art = new artist();
              art.id = m["album"]["artists"][j]["id"];
              art.title = m["album"]["artists"][j]["title"];
              item.album.artist_string += art.title + " ";
              item.album.artists.push(art);
            }

            this.medias[item.id] = item;

            resolve(item);

        });

        }
   else
      {
        resolve(this.medias[id]);
      }

    });



  }
}



// WEBPACK FOOTER //
// ./src/service/media.service.ts